module.exports = __webpack_public_path__ + "static/img/kdSimulator_5.56c5f19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdSimulator/kdSimulator_5.jpg
// module id = uwgu
// module chunks = 1